module.exports = __webpack_public_path__ + "static/ecanta-organik-trafik-0957a7f3c8642fa72b526d7d8935b022.png";